import React, { useCallback } from 'react';
import cx from 'classnames';

import { ReactComponent as SelectArrow } from 'app/components/svg/SelectArrow.svg';
import { TransactionSelectItemsEnum } from 'app/components/tables/TransactionsTable/select';
import Button from 'app/components/ui/Button';
import { withCloseByEmptySpace } from 'app/utils/withCloseByEmptySpace';
import { CloseByEmptySpaceType } from 'app/types/close-by-empty-space';

import s from './Select.module.sass';

type SelectProps = {
  items: {
    id: number
    type: string
  }[]
  handleSelect?: (arg: any) => void
  setActiveItem?: (arg: any) => void
  activeItem?: any
  theme?: keyof typeof themeClass
  className?: string
};

const themeClass = {
  primary: s.primary,
  secondary: s.secondary,
};

const Select: React.FC<SelectProps & CloseByEmptySpaceType> = ({
  items,
  dropdownRef,
  selectRef,
  active,
  setActive,
  handleSwitchDropdown,
  handleSelect,
  setActiveItem,
  activeItem,
  theme = 'primary',
  className,
}) => {
  const handleSetActiveItem = useCallback((value: any) => {
    if (setActiveItem) {
      setActiveItem(value);
    }
    setActive(false);

    if (handleSelect) {
      handleSelect({
        variables: {
          limit: 10,
          trxType: value === TransactionSelectItemsEnum.ALL ? '' : value,
        },
      });
    }
  }, [handleSelect, setActive, setActiveItem]);

  const compoundClassName = cx(
    s.root,
    { [s.open]: active },
    themeClass[theme],
    className,
  );

  return (
    <div className={compoundClassName}>
      <div
        className={cx(s.activeItem)}
        ref={selectRef}
      >
        {activeItem}

        <Button
          theme="clear"
          onClick={handleSwitchDropdown}
          className={cx(s.arrowButton)}
          sizeT="small"
        >
          <SelectArrow className={cx(s.arrowSvg)} />
        </Button>
      </div>

      <div className={cx(s.dropdown)} ref={dropdownRef}>
        {
          items.map(({ id, type }: any) => {
            if (type !== activeItem) {
              return (
                <div
                  key={id}
                  className={cx(s.item)}
                  onClick={() => handleSetActiveItem(type)}
                >
                  {type}
                </div>
              );
            }
            return undefined;
          })
        }
      </div>
    </div>
  );
};

export default withCloseByEmptySpace(Select);
